import { USER_CORPORATE_DATA } from '../../Types/UserCorporateDetails';

export const setUserCorporateData = (payload) => ({
  type: USER_CORPORATE_DATA,
  payload,
});
